export const ModalMode = {
  DEFAULT: 'default',
  FULLSCREEN: 'fullscreen',
  WIZARD: 'wizard',
};

export const ModalType = {
  GENERIC: 'generic',
  GENERIC_ERROR: 'genericError',
};

export const ModalVariant = {
  GENERIC: 'generic',
};

export const ModalSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

export const ModalInlineMessageType = {
  WARNING: 'warning',
  ERROR: 'error',
};
